/*
  Kiwi Ears · card lift (Rene 2026-08-21, simplified 2026-09-01).

  Subtle hover lift for product cards. Arm it by putting data-cardlift on a
  container — every .pk-pair-cell inside gets wired, so the series lineup, the
  PDP's "Pairs well with" and the homepage "Latest" rail share one implementation.

  History: v1 was a pointer-tracked 3D tilt. Halved once after review ("the
  effect is too strong"), then removed entirely 2026-09-01 ("just lift the card
  a little, the movement is too strong"). Emil's frequency rule settles it: a
  card hover is met dozens of times a day, so the whole performance is now a
  4px rise — enough to say "this is pressable", nothing more.

   · transform only; box-shadow is a class swap handled by CSS (.is-lift).
   · CSS-transition-like interruptibility via gsap overwrite:'auto' — flicking
     across a row never restarts from zero.
   · ease-out in (the eye is on the card as it arrives), quicker out.
   · Press feedback: a slight dip on pointerdown.
   · Skipped under prefers-reduced-motion and on coarse pointers.
*/
(function () {
  var mq = window.matchMedia;
  var reduce = mq && mq('(prefers-reduced-motion: reduce)').matches;
  var fine = mq ? mq('(hover: hover) and (pointer: fine)').matches : false;

  var RISE = -4;       /* px */
  var DIP = -1;        /* px while held */

  function wire(card) {
    if (card.dataset.lifted) return;
    card.dataset.lifted = '1';
    var gsap = window.gsap;
    var held = false;

    function settle(y, dur) {
      gsap.to(card, { y: y, duration: dur, ease: 'power3.out', overwrite: 'auto' });
    }

    card.addEventListener('pointerenter', function (ev) {
      if (ev.pointerType === 'touch') return;
      card.style.willChange = 'transform';
      card.classList.add('is-lift');
      settle(RISE, 0.2);
    });

    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-lift');
      held = false;
      /* leaving is quicker than arriving — the card is getting out of the way */
      gsap.to(card, {
        y: 0, duration: 0.28, ease: 'power3.out', overwrite: 'auto',
        onComplete: function () { card.style.willChange = ''; }
      });
    });

    card.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'touch') return;
      held = true;
      settle(DIP, 0.12);
    });
    ['pointerup', 'pointercancel'].forEach(function (e) {
      card.addEventListener(e, function () {
        if (!held) return;
        held = false;
        settle(RISE, 0.18);
      });
    });
  }

  function arm() {
    if (!window.gsap || reduce || !fine) return;
    document.querySelectorAll('[data-cardlift] .pk-pair-cell').forEach(wire);
  }

  /* arm() is idempotent (the data-lifted guard), so anything that injects cards
     after load can just ask for another pass. The wishlist page needs this —
     its cards arrive one fetch at a time, long after the load event. */
  window.KiwiCardLift = { arm: arm };
  document.addEventListener('kiwi:cards-added', function () { arm(); });

  if (document.readyState === 'complete') arm();
  else window.addEventListener('load', arm);
  /* Flickity re-parents cells into its slider; re-arm after that settles */
  window.addEventListener('resize', function () { setTimeout(arm, 220); });
})();
